import { EVoyageMissionType } from './missions/voyageMissionData'

export interface IVoyageNavData {
  locationName: string
  isStarbase: boolean
  missionType: EVoyageMissionType
}

let _navLocations: IVoyageNavData[] = []

export function getAll() {
  return _navLocations
}

export function registerAll() {
  _navLocations = [
    {
      locationName: 'Starbase-7',
      isStarbase: true,
      missionType: EVoyageMissionType.Starbase,
    },
    {
      locationName: 'Starbase-12',
      isStarbase: true,
      missionType: EVoyageMissionType.Starbase,
    },
    {
      locationName: 'Enemy territory',
      isStarbase: false,
      missionType: EVoyageMissionType.CombatZone1,
    },
    {
      locationName: 'Mission: hammerhead',
      isStarbase: false,
      missionType: EVoyageMissionType.FightAlienShip2,
    },
    {
      locationName: 'Mission: aliens 1',
      isStarbase: false,
      missionType: EVoyageMissionType.FightAliens1,
    },
    {
      locationName: 'Mission: aliens 2',
      isStarbase: false,
      missionType: EVoyageMissionType.FightAliens2,
    },
    {
      locationName: 'Mission: aliens 3',
      isStarbase: false,
      missionType: EVoyageMissionType.FightAliens3,
    },
  ]
}
